import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/icons-forms.svg'


const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "value", "placeholder", "disabled", "autocomplete", "type", "maxlength", "minlength"]
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "form-control-icon" }
const _hoisted_6 = ["value", "name", "id", "type", "placeholder", "disabled", "maxlength", "minlength"]
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { class: "form-control-icon" }
const _hoisted_9 = ["value", "name", "id", "placeholder", "disabled", "autocomplete", "maxlength", "minlength"]
const _hoisted_10 = {
  key: 5,
  class: "invalid-feedback"
}
const _hoisted_11 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "input-label p-small",
          for: _ctx.name
        }, _toDisplayString(_ctx.label) + " " + _toDisplayString(_ctx.requiredSymbol), 9, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.tooltipTitle)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          class: "icon ms-2 align-text-bottom",
          name: "circle-question",
          "data-bs-html": "true",
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "right",
          title: _ctx.tooltipTitle,
          style: "line-height: 1.65rem"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.type === "text")
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([_ctx.icon === "" ? "" : "form-control-icon"])
        }, [
          (!!_ctx.icon)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                class: "icon",
                name: _ctx.icon,
                style: _normalizeStyle("width: 1.25rem; height: 1.5rem;" + `color: var(--color-${_ctx.getColorIcon}); `)
              }, null, 8, ["name", "style"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            name: _ctx.name,
            id: _ctx.name,
            value: _ctx.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("update:modelValue", $event.target.value))),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("focused"))),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit("blured"))),
            class: _normalizeClass(["form-control", _ctx.errorLog ? "invalid" : ""]),
            placeholder: _ctx.placeholder,
            disabled: _ctx.isDisabled,
            autocomplete: _ctx.autocomplete,
            type: _ctx.isNumeric ? "tel" : "text",
            maxlength: _ctx.maxLength,
            minlength: _ctx.minLength
          }, null, 42, _hoisted_3), [
            [_directive_maska, _ctx.mask]
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.type === "password")
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              class: "icon",
              name: "lock-keyhole",
              style: _normalizeStyle("width: 1.25rem; height: 1.5rem;" + `color: var(--color-${_ctx.getColorIcon}); `)
            }, null, 8, ["style"]),
            _createElementVNode("input", {
              value: _ctx.modelValue,
              name: _ctx.name,
              id: _ctx.name,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit("update:modelValue", $event.target.value))),
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit("focused"))),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit("blured"))),
              type: _ctx.showPassword ? "text" : "password",
              class: _normalizeClass(["form-control", _ctx.errorLog ? "invalid" : ""]),
              placeholder: _ctx.placeholder,
              disabled: _ctx.isDisabled,
              maxlength: _ctx.maxLength,
              minlength: _ctx.minLength
            }, null, 42, _hoisted_6),
            (!_ctx.showPassword)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  class: "icon-right",
                  onClick: _ctx.toggleShowPassword,
                  name: "eye",
                  color: _ctx.iconColor,
                  style: {"width":"1.35rem","height":"1.5rem"}
                }, null, 8, ["onClick", "color"]))
              : (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  class: "icon-right",
                  onClick: _ctx.toggleShowPassword,
                  name: "eye-slash",
                  color: "--color-dark-gray",
                  style: {"width":"1.35rem","height":"1.5rem"}
                }, null, 8, ["onClick"]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === "phone")
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              class: "icon",
              src: _imports_0
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              value: _ctx.modelValue,
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit("update:modelValue", $event.target.value))),
              onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit("focused"))),
              onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit("blured"))),
              name: _ctx.name,
              id: _ctx.name,
              class: _normalizeClass(["form-control", _ctx.errorLog ? "invalid" : ""]),
              placeholder: _ctx.placeholder,
              disabled: _ctx.isDisabled,
              autocomplete: _ctx.autocomplete,
              maxlength: _ctx.maxLength,
              minlength: _ctx.minLength
            }, null, 42, _hoisted_9), [
              [_directive_maska, ["+55 (##) ####-####", "+55 (##) #####-####"]]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!!_ctx.errorLog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.errorLog), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}